/* eslint-disable react-hooks/exhaustive-deps */
// I just want use effect for a single value
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./css/index.scss";

const Toaster = ({ color, icon, title, text, millis, visible, onClose }) => {
  const [isOpen, setIsOpen] = useState(visible);
  useEffect(() => {
    let timeOut = 0;
    if (millis > 0 && isOpen) {
      timeOut = setTimeout(() => {
        setIsOpen(false);
        onClose();
      }, millis);
    }
    return () => {
      clearTimeout(timeOut);
    };
  }, [isOpen, millis]);
  return (
    <div className="toaster">
      <div className="toaster-band" style={{ backgroundColor: color }} />
      {React.isValidElement(icon) ? (
        <div className="toaster-icon">{icon}</div>
      ) : (
        <div className="toaster-icon">
          <span style={{ color }} className={icon} />
        </div>
      )}
      <div className="toaster-container">
        <div className="toaster-title">
          <h4 className="toaster-title-text">{title}</h4>
        </div>
        <div className="toaster-text">{text}</div>
      </div>
    </div>
  );
};
const defaultPropTypes = {
  color: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.string,
  text: PropTypes.string,
  millis: PropTypes.number,
  visible: PropTypes.bool,
  onClose: PropTypes.func
};
Toaster.propTypes = defaultPropTypes;
const defaultProps = {
  color: "white",
  icon: "icono-info",
  title: "",
  text: "",
  millis: 3000,
  visible: true,
  onClose: () => {}
};
Toaster.defaultProps = defaultProps;
export const Warning = ({ id, color, icon, title, text, millis, visible, onClose }) => {
  useEffect(() => {
    if (visible) {
      toast(<Toaster color={color} icon={icon} title={title} text={text} millis={0} visible />, {
        onClose: () => onClose(),
        autoClose: millis,
        className: "custom-toast",
        hideProgressBar: true
      });
    }
  }, [visible]);
  return <div />;
};
Warning.propTypes = {
  ...defaultPropTypes,
  id: PropTypes.string
};
Warning.defaultProps = {
  ...defaultProps,
  icon: "icono-warning",
  color: "#f0a41c",
  id: ""
};

export const Info = ({ color, icon, title, text, closeButton, millis, visible, onClose }) => {
  return toast.info(
    <Toaster
      color={color}
      icon={icon}
      title={title}
      text={text}
      closeButton={closeButton}
      millis={millis}
      onClose={onClose}
      visible={visible}
    />,
    {
      className: "toast-info"
    }
  );
};
Info.propTypes = defaultPropTypes;
Info.defaultProps = {
  ...defaultProps,
  icon: "icono-info",
  color: "#48b5ff"
};
export const Success = ({ icon, color, title, text, millis, visible, onClose }) => {
  useEffect(() => {
    if (visible) {
      toast(<Toaster color={color} icon={icon} title={title} text={text} millis={0} visible />, {
        onClose: () => onClose(),
        autoClose: millis,
        className: "custom-toast",
        hideProgressBar: true
      });
    }
  }, [visible]);
  return <div />;
};
Success.propTypes = defaultPropTypes;
Success.defaultProps = {
  ...defaultProps,
  icon: "icono-tick",
  color: "#0abd6f"
};
export const Error = ({ color, icon, title, text, millis, visible, onClose }) => {
  useEffect(() => {
    if (visible) {
      toast(<Toaster color={color} icon={icon} title={title} text={text} millis={0} visible />, {
        onClose: () => onClose(),
        autoClose: millis,
        className: "custom-toast",
        hideProgressBar: true
      });
    }
  }, [visible]);
  return <div />;
};
Error.propTypes = defaultPropTypes;
Error.defaultProps = {
  ...defaultProps,
  icon: "icono-alert",
  color: "#d52b1e"
};
export default Toaster;
